import { render, staticRenderFns } from "./TANav-Jpn.vue?vue&type=template&id=bcfe2ea8&scoped=true&"
import script from "./TANav-Jpn.vue?vue&type=script&lang=js&"
export * from "./TANav-Jpn.vue?vue&type=script&lang=js&"
import style0 from "./TANav-Jpn.vue?vue&type=style&index=0&id=bcfe2ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfe2ea8",
  null
  
)

export default component.exports